var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.rows),function(r){return _c('div',{key:r,ref:"childComponent",refInFor:true},[_c('updating_metrics',{attrs:{"updating_metrics":_vm.vizDataRowCol[_vm.screenlet][r]}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }